import { OrgAdminConstants } from '../../../_constants';

const initialState = { changeModuleAccessLoading: true, data: '', error: false };

export function changeModuleAccessReducer(state = initialState, action) {

    switch (action.type) {
        case OrgAdminConstants.REQUEST_MODULE_CHANGE_ACCESS:
            return {
                changeModuleAccessLoading: true,
                data: '',
                error: false
            };
        case OrgAdminConstants.RECEIVE_MODULE_CHANGE_ACCESS:
            return {
                changeModuleAccessLoading: false,
                data: action.changeAccess,
                error: false
            };
        case OrgAdminConstants.MODULE_CHANGE_ACCESS_ERROR:
            return {
                changeModuleAccessLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/OrgAdmin/ModulePermissions/changeModuleAccess.reducer.js